import React, { useEffect, useState } from "react";
import Contact from "../Contact/Contact";
import ContactMob from "../ContactMob/ContactMob";

const ContactWrapper = ({setCursorText}) => {

    const [isMobileView, setIsMobileView] = useState(null);


    const responsiveResize = () => {
        let curWidth = window.innerWidth;
        if(curWidth <= 600) setIsMobileView(true);
        else setIsMobileView(false);
    }

    useEffect(() => {
        responsiveResize()
        window.addEventListener("resize", responsiveResize, false);
        setCursorText("")
        return () => {
            window.removeEventListener("resize", responsiveResize, false);
        };
    }, [])

    return(
        <>
            {
                isMobileView !== null ?
                    isMobileView  ?
                        <ContactMob />
                    :
                        <Contact />
                : <React.Fragment />
            }
        </>
    )
}

export default ContactWrapper;